import { buildAuthFunctions } from '../helpers.js';

const authFunctions = buildAuthFunctions('clients');

export default {
    changeOwner: authFunctions.manage,
    ...authFunctions,
};